const registeredErrorMessages = [
    'paypalUnauthorized',
    'invalidPaymentType',
    'paypalCaptureError',
    'invalidIban',
    'noAnonymousContact'
]

export default {
    async fetchProjectData({commit}, {projectId, fundraiser}) {
        const {$axios, $apiRoute} = useNuxtApp()
        try {
            commit('setProjectIsLoaded', false)
            let responseData = (await $axios.get($apiRoute('api.fundraising.projects.show', {project: projectId}), {params: {fundraiser}})).data
            commit('setFormSelectChoices', responseData.formSelectChoices)
            commit('setFundraiserData', responseData.fundraiserData)
            commit('setProjectData', responseData.projectData)
            commit('setProjectIsLoaded', true)
            if (responseData.ci) {
                useNuxtApp().$applyCi(responseData.ci, {standalone: true})
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    showError({statusCode: 403, message: "not_found"})
                } else if (error.response.status === 403) {
                    showError({statusCode: 403, message: error.response.data?.message, data: error.response.data})
                } else if (error.response.status === 500) {
                    showError({statusCode: 500})
                }
            } else {
                console.log(error)
            }
        }
    },

    async fetchDonorInformation({commit}, {donorHint, donorData}) {
        const {$axios, $apiRoute} = useNuxtApp()
        $axios.get(
            $apiRoute('api.fundraising.getDonorInformation', {donorHint: donorHint, donorData: donorData}),
        ).then(response => {
            commit('setDonorInformation', response.data.data)
        }).catch(() => {
            // console.log(error)
        })
    },

    async sendDonation({commit, state}, fundraiser) {
        const {$axios, $apiRoute, $notify, $i18n} = useNuxtApp()
        try {
            commit('setProjectIsLoaded', false)
            const response = await $axios.post($apiRoute('api.fundraising.projects.donation.store', {project: state.projectData?.id}),
                {...state.donationData, fundraiser: fundraiser || state.fundraiserData?.code || null},
            )
            commit('setDonationProp', {prop: "id", value: response.data.id})
            commit('setDonationFinishedSuccessful', true)
            commit('setProjectIsLoaded', true)
            return response
        } catch (e) {
            console.log(e)
            commit('setProjectIsLoaded', true)
            if (e.response && e.response.data && registeredErrorMessages.includes(e.response.data.message)) {
                $notify({
                    type: 'danger',
                    message: $i18n.t('error.' + e.response.data.message),
                    timeout: 15000
                })
            } else {
                $notify({
                    type: 'danger',
                    message: $i18n.t('error.errorWhileDonation'),
                    timeout: 15000
                })
                sendFailDonationInfo(state, e)
            }
        }
    }
}

function sendFailDonationInfo(state, error) {
    const {$axios, $apiRoute} = useNuxtApp()
    $axios.post($apiRoute('api.fundraising.donationFailure'), {
        donationVueData: state,
        donationResponse: error?.response ? error.response : null,
        donationRequest: error?.request ? error.request : null,
        donationRequestConfig: error?.config ? error.config : null,
        donationRequestMessage: error?.message ? error.message : null
    })
}
